import React from "react";
import { Container, Grid, Typography, Box, useMediaQuery, useTheme } from "@mui/material";

const CompanySection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ padding: "2rem 0", 
      // backgroundColor: "#000", 
    color: "#fff" }}>
      <Container>
        <Typography variant="h4" align="center" gutterBottom sx={{ color: "#E6E6FA", fontWeight: 700 }}>
          Where Excellence and Innovation Collide
        </Typography>
        <Typography variant="subtitle1" align="center" paragraph sx={{ color: "#fff" }}>
          The enduring principles of integrity, creativity, and reliability are the cornerstone of our business.
          Our customers trust us with both their data and their digital aspirations. And we take this trust seriously.
        </Typography>
        <Typography variant="subtitle1" align="center" paragraph sx={{ color: "#fff" }}>
          Join us on this journey where we strive for quality and use innovation as our compass.
          Together, we can unlock the possibilities of the future now.
        </Typography>

        <Grid container spacing={5} alignItems="center" sx={{ marginTop: "2rem" }}>
          <Grid item lg={6} md={12} sx={{ textAlign: { xs: "center", lg: "left" } }}>
            <img
              src="/img/frame/frame.png" 
              alt="Tech Desk"
              style={{ width: "100%", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
            />
          </Grid>
          <Grid item lg={6} md={12}>
            <Typography variant="h4" gutterBottom sx={{ color: "#E6E6FA" }}>
              Our Story
            </Typography>
            <Typography paragraph sx={{ color: "#fff" }}>
              It all started with a vision, to use technology to its full potential and make it available to everyone.
              We are a stronghold in the tech industry today. Our narrative is one of ongoing development, discovery, and change.
            </Typography>
            <Typography paragraph sx={{ color: "#fff" }}>
              We started off as a small IT consultant but have now grown to become a one-stop shop for everything tech.
              These days, we offer web development, staff augmentation, digital marketing, and comprehensive corporate marketing solutions.
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={5} alignItems="center" sx={{ marginTop: "2rem" }}>
          <Grid item lg={6} md={12} sx={{ order: { xs: 2, lg: 2 }, textAlign: { xs: "center", lg: "left" } }}>
            <img
              src="/img/frame/frame-1.png"
              alt="Developer Working"
              style={{ width: "100%", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
            />
          </Grid>
          <Grid item lg={6} md={12} sx={{ order: { xs: 1, lg: 1 } }}>
            <Typography variant="h4" gutterBottom sx={{ color: "#E6E6FA" }}>
              Europa Effects
            </Typography>
            <Typography paragraph sx={{ color: "#fff" }}>
              We stand out not only for the variety of services we offer but also for our unwavering dedication to quality.
              We recognize that technology is a tool to improve people's lives and enterprises, not a stand-alone entity.
            </Typography>
            <Typography paragraph sx={{ color: "#fff" }}>
              Working with us gives you more than simply a service provider. We not only offer solutions,
              but also find answers for your issues. We are here to help you navigate the digital labyrinth,
              make difficult issues easier to understand, and get you where you want to go.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CompanySection;